import { useState } from 'react'

import { Container } from 'components/container'
import { Layout } from 'components/layout'
import { useDataContext } from 'context/data-context'
import { VideoPlayer } from './video-player'
import { Grid } from './grid'
import { EpisodeTile } from './episode-tile'
import { Header, HeroVideo, List } from './styled'

export const Home = () => {
  const { strings, episodes } = useDataContext()
  const [activeEpisodeIndex, setActiveEpisodIndex] = useState(-1)

  return (
    <Layout>
      <Header>
        <HeroVideo muted autoPlay loop playsInline>
          <source src={strings.hero_media} />
        </HeroVideo>

        <Container $fluid>
          <div>
            <h1>{strings.title}</h1>
            <p>{strings.intro}</p>
          </div>
        </Container>
      </Header>
      <Container $fluid>
        <List>
          {episodes.map((episode, index) => (
            <EpisodeTile
              key={index}
              episode={episode}
              onClick={() => setActiveEpisodIndex(index)}
            />
          ))}
        </List>
      </Container>
      {activeEpisodeIndex >= 0 && (
        <VideoPlayer
          activeEpisodeIndex={activeEpisodeIndex}
          onClose={() => setActiveEpisodIndex(-1)}
        />
      )}
      {/* <Grid /> */}
    </Layout>
  )
}
